import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { JSX } from 'react';
import { Button } from './button.js';

/** Pagination — `02` §0 : 50 lignes par page. Générique, utilisée par `DataTable`. */
export interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

export function Pagination({
  page,
  totalPages,
  onPageChange,
  disabled = false,
}: PaginationProps): JSX.Element {
  const safeTotalPages = Math.max(1, totalPages);
  const canGoPrevious = page > 1 && !disabled;
  const canGoNext = page < safeTotalPages && !disabled;

  return (
    <nav className="flex items-center gap-3" aria-label="Pagination">
      <p className="text-xs tabular-nums text-muted-foreground">
        Page {page} sur {safeTotalPages}
      </p>
      <div className="flex items-center gap-1">
        <Button
          type="button"
          variant="outline"
          size="icon-sm"
          disabled={!canGoPrevious}
          onClick={() => {
            onPageChange(page - 1);
          }}
          aria-label="Page précédente"
        >
          <ChevronLeft aria-hidden="true" />
        </Button>
        <Button
          type="button"
          variant="outline"
          size="icon-sm"
          disabled={!canGoNext}
          onClick={() => {
            onPageChange(page + 1);
          }}
          aria-label="Page suivante"
        >
          <ChevronRight aria-hidden="true" />
        </Button>
      </div>
    </nav>
  );
}
